/**
 * Insurance Error Component
 *
 * Error screen when insurance verification fails
 */

"use client";

import { Button } from "@frontend/shared/components/ui/button";
import { AlertCircle } from "lucide-react";
import { useTranslations } from "@frontend/lib/next-intl-typed";
import {
  useInsuranceConnectorContext,
  useInsuranceConnectorSend,
} from "../insurance-connector-provider";

export function InsuranceError() {
  const context = useInsuranceConnectorContext();
  const send = useInsuranceConnectorSend();
  const t = useTranslations("InsuranceConnector");

  return (
    <div className="p-6 space-y-6">
      <div className="flex flex-col items-center justify-center py-8 space-y-4">
        <AlertCircle className="h-12 w-12 text-destructive" />
        <div className="text-center space-y-2">
          <h2 className="text-2xl font-bold">{t("UnableToVerifyInsurance")}</h2>
          <p className="text-muted-foreground">
            {context.error?.message || t("ProblemVerifyingInsurance")}
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-3">
        <Button onClick={() => send({ type: "RETRY" })} className="w-full">
          {t("TryAgain")}
        </Button>
        <Button
          onClick={() => send({ type: "SKIP" })}
          variant="outline"
          className="w-full"
        >
          {t("ContinueWithoutInsurance")}
        </Button>
      </div>
    </div>
  );
}
